import {
    GET_INVOICE_TITLE_LIST_PROGRESS, GET_INVOICE_TITLE_LIST_SUCCESS, GET_INVOICE_TITLE_LIST_FAILURE,
    ADD_INVOICE_TITLE_PROGRESS, ADD_INVOICE_TITLE_SUCCESS, ADD_INVOICE_TITLE_FAILURE,
    EDIT_DELETE_INVOICE_TITLE_PROGRESS, EDIT_DELETE_INVOICE_TITLE_SUCCESS, EDIT_DELETE_INVOICE_TITLE_FAILURE,
   
    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    invoicePrintTitle: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const invoice_print_title_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_INVOICE_TITLE_LIST_SUCCESS:
            return { ...state, invoicePrintTitle: action.invoicePrintTitle, loading: false };
        case GET_INVOICE_TITLE_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_INVOICE_TITLE_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_INVOICE_TITLE_PROGRESS:
            return { ...state, loading: true };
        case ADD_INVOICE_TITLE_SUCCESS:
            return { ...state, invoicePrintTitle: [...state.invoicePrintTitle, action.payload], loading: false, error: false,  message: action.payload.message };
        case ADD_INVOICE_TITLE_FAILURE:
            return { ...state, loading: false, error: action.payload,  message: action.payload.message };
        case EDIT_DELETE_INVOICE_TITLE_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_INVOICE_TITLE_SUCCESS:
            return {
                ...state,
                invoicePrintTitle: state.invoicePrintTitle.map((invoicePrintTitle) =>
                    invoicePrintTitle.id === action.payload.id ? action.payload : invoicePrintTitle
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_INVOICE_TITLE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
     
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default invoice_print_title_reducer;